module.exports = __webpack_public_path__ + "img/wm-icon.588b5d69.svg";